import { useEffect } from 'react';
import { isOtaWebReactionStarted } from '../utils/otaUtils';

export const useConfirmBeforeExit = (shouldPrompt: boolean) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // A forced update must win: staying cannot save the data (every request is refused), so no prompt.
      if (shouldPrompt && !isOtaWebReactionStarted()) {
        event.preventDefault();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [shouldPrompt]);
};
